import { getRandom } from "../../../common/RandomNumber";

export const get_point = (value, price)=>{

  let point = 0;

  const levelList = { 
    1: [//1000
      1000, 0, 0, 100, 0, 300, 0 , 500, 500, 100
    ],
    2: [//2500
      1000, 2500, 0, 100, 0, 300, 0 , 500, 500, 100
    ],
    3: [//5000
      1000, 0, 0, 100, 0, 300, 0 , 500, 500, 100
    ],
    4: [//8000
      1000, 0, 0, 100, 0, 300, 0 , 500, 500, 100
    ],
    5: [//13900
      1000, 0, 0, 100, 0, 300, 0 , 500, 500, 100
    ],
    6: [//29900
      1000, 0, 0, 100, 0, 300, 0 , 500, 500, 100
    ],
  };

  switch(value){
    case 1 : point = Number(getRandom(-price / 3, price * 2.5)); break; //1000
    case 2 : point = Number(getRandom(-price / 3, price * 2.5)); break; //2500
    case 3 : point = Number(getRandom(-price / 3, price * 2.5)); break; //5000
    case 4 : point = Number(getRandom(-price / 3, price * 2.5)); break; //8000
    case 5 : point = Number(getRandom(-price / 3, price * 2.5)); break; //13900
    case 6 : point = Number(getRandom(-price / 3, price * 2.5)); break; //29900
    default : break;
  }

  return point;
};